var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _taggedTemplateLiteral = require("/workspace/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ws = require('isomorphic-ws');

var _require = require('subscriptions-transport-ws'),
    SubscriptionClient = _require.SubscriptionClient;

var _require2 = require('graphql-request'),
    request = _require2.request,
    gql = _require2.gql;

var _require3 = require("date-fns"),
    subWeeks = _require3.subWeeks,
    getUnixTime = _require3.getUnixTime,
    fromUnixTime = _require3.fromUnixTime;

var _require4 = require('./../../constants'),
    graphAPIEndpoints = _require4.graphAPIEndpoints,
    graphWSEndpoints = _require4.graphWSEndpoints;

var _require5 = require('./../../utils'),
    timestampToBlock = _require5.timestampToBlock,
    timestampsToBlocks = _require5.timestampsToBlocks;

module.exports = {
  ethPrice: function ethPrice() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$block, block, _ref$timestamp, timestamp, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$block = _ref.block, block = _ref$block === void 0 ? undefined : _ref$block, _ref$timestamp = _ref.timestamp, timestamp = _ref$timestamp === void 0 ? undefined : _ref$timestamp;

              if (!block) {
                _context.next = 5;
                break;
              }

              _context.t0 = block;
              _context.next = 13;
              break;

            case 5:
              if (!timestamp) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return timestampToBlock(timestamp);

            case 8:
              _context.t1 = _context.sent;
              _context.next = 12;
              break;

            case 11:
              _context.t1 = undefined;

            case 12:
              _context.t0 = _context.t1;

            case 13:
              block = _context.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              _context.next = 17;
              return request(graphAPIEndpoints.exchange, gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n                    bundle(id: 1, ", ") {\n                        ", "\n                    }\n                }"])), block, _ethPrice.properties.toString()));

            case 17:
              result = _context.sent;
              return _context.abrupt("return", _ethPrice.callback(result.bundle));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  ethPriceHourly: function ethPriceHourly() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref2, _ref2$minTimestamp, minTimestamp, _ref2$maxTimestamp, maxTimestamp, _ref2$minBlock, minBlock, _ref2$maxBlock, maxBlock, endTime, time, timestamps, blocks, query, result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref2$minTimestamp = _ref2.minTimestamp, minTimestamp = _ref2$minTimestamp === void 0 ? undefined : _ref2$minTimestamp, _ref2$maxTimestamp = _ref2.maxTimestamp, maxTimestamp = _ref2$maxTimestamp === void 0 ? undefined : _ref2$maxTimestamp, _ref2$minBlock = _ref2.minBlock, minBlock = _ref2$minBlock === void 0 ? undefined : _ref2$minBlock, _ref2$maxBlock = _ref2.maxBlock, maxBlock = _ref2$maxBlock === void 0 ? undefined : _ref2$maxBlock;
              minTimestamp = minBlock ? blockToTimestamp(minBlock) : minTimestamp;
              maxTimestamp = maxBlock ? blockToTimestamp(maxBlock) : maxTimestamp;
              endTime = maxTimestamp ? fromUnixTime(maxTimestamp) : new Date();
              time = minTimestamp ? minTimestamp : getUnixTime(subWeeks(endTime, 1)); // create an array of hour start times until we reach current hour

              timestamps = [];

              while (time <= getUnixTime(endTime) - 3600) {
                timestamps.push(time);
                time += 3600;
              }

              _context2.next = 9;
              return timestampsToBlocks(timestamps);

            case 9:
              blocks = _context2.sent;
              query = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{\n                ", "\n            }"])), blocks.map(function (block, i) {
                return gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                    timestamp", ": bundle(id: 1, block: {number: ", "}) {\n                        ", "\n                }"])), timestamps[i], block, _ethPrice.properties.toString());
              }));
              _context2.next = 13;
              return request(graphAPIEndpoints.exchange, query);

            case 13:
              result = _context2.sent;
              result = Object.keys(result).map(function (key) {
                return _objectSpread(_objectSpread({}, result[key]), {}, {
                  timestamp: key.split("timestamp")[1]
                });
              }).sort(function (a, b) {
                return Number(a.timestamp) - b.timestamp;
              });
              return _context2.abrupt("return", _ethPrice.callbackHourly(result));

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  observeEthPrice: function observeEthPrice() {
    var query = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            subscription {\n                bundle(id: 1) {\n                    ", "\n                }\n        }"])), _ethPrice.properties.toString());
    var client = new SubscriptionClient(graphWSEndpoints.exchange, {
      reconnect: true
    }, ws);
    var observable = client.request({
      query: query
    });
    return {
      subscribe: function subscribe(_ref3) {
        var _next = _ref3.next,
            error = _ref3.error,
            complete = _ref3.complete;
        return observable.subscribe({
          next: function next(results) {
            _next(_ethPrice.callback(results.data.bundle));
          },
          error: error,
          complete: complete
        });
      }
    };
  }
};
var _ethPrice = {
  properties: ['ethPrice'],
  callback: function callback(results) {
    return Number(results.ethPrice);
  },
  callbackHourly: function callbackHourly(results) {
    return results.map(function (result) {
      return {
        timestamp: Number(result.timestamp),
        priceUSD: Number(result.ethPrice)
      };
    });
  }
};